<p>
  You have logged out
</p>
